import { Check } from "lucide-react";

export function OptionList({ name, options, value, onChange, testIdPrefix }) {
  return (
    <div className="space-y-2" role="radiogroup" aria-label={name}>
      {options.map((opt) => {
        const selected = value === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(opt.id)}
            data-selected={selected}
            data-testid={`${testIdPrefix}-${opt.id}`}
            className="cc-option"
          >
            <span
              className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${
                selected
                  ? "border-[hsl(var(--olivo))] bg-[hsl(var(--olivo))]"
                  : "border-[hsl(33_25%_75%)] bg-white"
              }`}
              aria-hidden="true"
            >
              {selected && <Check className="h-3 w-3 text-white" />}
            </span>
            <span className="text-[hsl(var(--texto))] font-medium">
              {opt.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
